import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  EvidenceValue,
  IEvidenceSnapshotModel,
} from 'src/app/shared/models/credential/personScenarioEvidenceDetails';
import { AppConfigService } from 'src/app/shared/services/app-config.service';
import { AWSService } from 'src/app/shared/services/aws.service';

const credentialNeverIssued = [null];
@Component({
  selector: 'evidence-snapshot',
  templateUrl: './evidence-snapshot.component.html',
  styleUrls: ['./evidence-snapshot.component.scss'],
})
export class EvidenceSnapshotComponent {
  @Input()
  evidence: IEvidenceSnapshotModel;
  @Input()
  showAllFields: boolean;
  @Input()
  openEvidenceFile: (filename: string, evidence: IEvidenceSnapshotModel) => void;

  getEvidenceValues() {
    if (this.evidence.evidenceType === 'Credential' && !this.evidence.evidenceValue.length) {
      return credentialNeverIssued; //hacky way to render never issued (empty) credentials in the credential-snapshot component
    }
    return this.evidence.evidenceValue;
  }

  openEvidenceImageInS3 = (fileName: EvidenceValue, evidence: IEvidenceSnapshotModel) =>
    this.openEvidenceFile(fileName as string, evidence);
}
